import { render } from "./App.vue?vue&type=template&id=f92fa222&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f92fa222&lang=css"

import exportComponent from "C:\\Users\\Dylank\\source\\repos\\DylanKral\\Portfolio-Project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__